document.addEventListener('DOMContentLoaded', function() {
  // Find all elements with the 'text-truncate' class
  var elements = document.querySelectorAll('.text-truncate');
  
  elements.forEach(function(element) {
    var fullText = element.innerHTML;
    var words = fullText.split(' ');
    
    if (words.length > 30) {
      // Create truncated version
      var truncatedText = words.slice(0, 30).join(' ') + '...';
      
      // Create the toggle button
      var toggleButton = document.createElement('a');
      toggleButton.href = '#';
      toggleButton.className = 'toggle-text';
      toggleButton.textContent = 'See more';
      
      // Set initial state
      element.innerHTML = truncatedText;
      element.appendChild(toggleButton);
      
      // Save full text
      element.setAttribute('data-full-text', fullText);
      
      // Add click event
      toggleButton.addEventListener('click', function(e) {
        e.preventDefault();
        
        if (toggleButton.textContent === 'See more') {
          element.innerHTML = fullText;
          element.appendChild(toggleButton);
          toggleButton.textContent = 'See less';
        } else {
          element.innerHTML = truncatedText;
          element.appendChild(toggleButton);
          toggleButton.textContent = 'See more';
        }
      });
    }
  });
});
